// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ExistingOrganisationParty-module__section___3ilfC{margin-top:20px}.ExistingOrganisationParty-module__inputBox___YUVox{border-radius:4px;border:solid 1px #494d56;padding:10px;margin-top:6px;width:100%}.ExistingOrganisationParty-module__errorMessage___1p3hy{margin-top:-15px}", ""]);
// Exports
exports.locals = {
	"section": "ExistingOrganisationParty-module__section___3ilfC",
	"inputBox": "ExistingOrganisationParty-module__inputBox___YUVox",
	"errorMessage": "ExistingOrganisationParty-module__errorMessage___1p3hy"
};
module.exports = exports;
